export const MAIN_ROUTE = '/casinaki-project/'
export const LOGIN_ROUTE = '/casinaki-project/login'
export const ADMIN_ROUTE = '/casinaki-project/admin'
export const REGISTER_ROUTE = '/casinaki-project/register'
export const DEPOSIT_ROUTE = '/casinaki-project/deposit'
export const HI_LOW_ROUTE = '/casinaki-project/hilow'
export const DICE_ROUTE = '/casinaki-project/dice'
export const MINER_ROUTE = '/casinaki-project/miner'
export const BLACKJACK_ROUTE = '/casinaki-project/blackjack'
export const PROFILE_ROUTE = '/casinaki-project/profile'
export const RANKS_ROUTE = '/casinaki-project/ranks'
export const REVIEWS_ROUTE = '/casinaki-project/reviews'

export const GREEN_BTN_COLOR = '#47924d'

export const MIN_BET = 0.1
export const MAX_BET = 999999.99

export const overDiceCoefficients = [1.07, 1.19, 1.33, 1.52, 1.79, 2.13, 2.67, 3.56, 5.36, 10.67, 0]
export const underDiceCoefficients = [0, 10.67, 5.36, 3.56, 2.67, 2.13, 1.79, 1.52, 1.33, 1.19, 1.07]

export const sapperAnecdotes = [
	'Чем отличается десантник от сапера? - направлением полета.',
	'Дети саперов едят манную кашу не задевая комочков.',
	'Сапер ошибается два раза в жизни: \n- Первый раз при выборе профессии, второй раз - когда женится.',
	'До старости доживает не тот сапер, который чувствует, где мины, а тот, кто их ставит.',
	'"Ноги моей здесь больше не будет" - подумал сапер, наступая на мину.',
	'— Дяденька сапер, а зачем у тебя рюкзак на спине? \n— Это не рюкзак! Это парашют!!',
	'Учиться на своих ошибках — довольно распространенная практика.\n Но саперы были вынуждены пойти другим путем.',
	'Опытный сапер Вася ошибся один раз и... пришлось жениться.',
	'Вчера на разминировании противотанковой мины сапер Петров опроверг расхожее мнение о том, что невозможно увидеть свои уши без зеркала.',
	'Мечта многих девушек - выйти замуж за богатого сапера...',
	'Саперы ходят медленно, но лучше их не обгонять.',
	'Сапер спер мину и взорвался.',
	'Если есть cекc-бомбы, то должны быть cекc-саперы! С большим миноискателем.',
	'Салат мясной "Ошибка сапера"',
	'Нелюбимая поговорка саперов: Одна нога здесь, другая - там.',
	'Один сапер подходит к другому и говорит: \n— Мин нет? \n— Давай.',
	'Десантник, если у него не раскроется парашют, может лететь со скоростью 50 м/сек. \nБыстрее может лететь только сапер.',
]
